import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { RegexService } from 'src/app/services/regex.service';
import * as Countries from 'src/assets/json/countries.json';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix, MatHint, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-add-company-dialog',
  templateUrl: './add-company-dialog.component.html',
  styleUrls: ['./add-company-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatSuffix,
    MatHint,
    MatCheckbox,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatPrefix,
  ],
})
export class AddCompanyDialogComponent implements OnInit {
  protected fb = inject(UntypedFormBuilder);
  dialogRef = inject<MatDialogRef<AddCompanyDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private regex = inject(RegexService);

  companyForm: UntypedFormGroup;
  countries: any[] = (Countries as any).default;

  constructor() {
    const regex_patterns = this.regex.getRegex();

    this.companyForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern(regex_patterns['phone'])])],
      fact_name: ['', Validators.compose([Validators.required])],
      fact_address: ['', Validators.compose([Validators.required])],
      fact_city: ['', Validators.compose([Validators.required])],
      fact_zipcode: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
      fact_county: ['', Validators.compose([Validators.required])],
      fact_country: ['', Validators.compose([Validators.required])],
      fact_country_alpha2: ['', Validators.compose([Validators.required])],
      create_user: [false],
      vat: ['', Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
    this.listenCountryChanges();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private listenCountryChanges() {
    this.companyForm.controls['fact_country'].valueChanges.subscribe(data => {
      for (const c of this.countries) {
        if (c.name == data) {
          this.companyForm.patchValue({ fact_country_alpha2: c.alpha_2 });
          break;
        }
      }
    });
  }
}
